import imagesLoaded from "imagesloaded";
import { timeCount } from "./clock.js";
import { videoPlay } from "./video.js";

/* Check >
https://github.com/rollup/rollup-starter-code-splitting/blob/master/src/main-a.js
https://fuzzytolerance.info/blog/2019/12/09/Code-Splitting-and-Module-Loading-with-Rollup/
*/

const body = document.querySelector("body");
const main = document.querySelector("#main");
const header = document.querySelector("header");
const animationDelay = 350;
const animationDelay2 = 700;

function goTo(href) {
  body.classList.add("loading");
  window.scroll({ top: 0, left: 0, behavior: "smooth" });

  const xhr = new XMLHttpRequest();
  xhr.responseType = "document";
  xhr.onload = showResult;
  xhr.open("GET", href, true);
  xhr.send();

  function showResult(data) {
    const Vanillaresponse = xhr.responseXML,
    selectmain = Vanillaresponse.querySelector("#main").innerHTML,
    selectheader = Vanillaresponse.querySelector("header").innerHTML,
    targetTitle = Vanillaresponse.head.querySelector("title").textContent;
    let targetDesc;
    if (Vanillaresponse.querySelector("meta[name='description']")) {
      targetDesc = Vanillaresponse.querySelector("meta[name='description']").getAttribute("content");
    }

    document.head.querySelector("title").textContent = targetTitle;
    const metaDesc = document.querySelector("meta[name='description']")
    if (metaDesc && targetDesc) {
      metaDesc.setAttribute("content", targetDesc);
    }

    setTimeout(function () {
      main.innerHTML = selectmain;
      header.innerHTML = selectheader;
      loadImage();
      videoPlay();
    }, animationDelay);

    setTimeout(function () {
      body.classList.remove("loading");
      if (document.getElementById("me") !== null) {
        import("./matter-script").then(({ default : floatyBubbles }) => {
          floatyBubbles.init();
        });
      };
    }, animationDelay2);
  }
}

/*!
* appel ajax
*/
document.addEventListener("DOMContentLoaded", function (event) {
  if (typeof history.pushState !== "undefined") {
    let historyCount = 0;

    document.addEventListener("click", function (event) {
      if (event.target.matches("a:not([target='_blank']):not([href^='mailto:'])")) {
        const href = event.target.getAttribute("href");
        goTo(href);
        history.pushState(null, null, href);
        event.preventDefault();
        return false;
      }
    }, false);

    window.onpopstate = function () {
      goTo(document.location);
      historyCount = historyCount + 1;
    };
  }
});

/*!
* appel normal
*/
document.addEventListener("DOMContentLoaded", function (event) {
  loadImage();
  videoPlay();
  if (document.getElementById("me") !== null) {
    import("./matter-script").then(({ default : floatyBubbles }) => {
      floatyBubbles.init();
    });
  }

  if (document.getElementById("clock") !== null) {
    setInterval(timeCount, 1000);
  }

  // Resize handler
  const handleResize = function (e) {
    const resizeEvent = typeof e !== "undefined" ? e : false;
  }

  if (!("orientationchange" in window)) {
    window.addEventListener("resize", function () {
      handleResize(true);
    });
  } else {
    window.addEventListener("orientationchange", function () {
      handleResize(true);
    });
  }
  handleResize(false);
  netlifyAdmin();
});

function loadImage() {
  let fit = document.querySelectorAll(".fit-img");
  return fit.forEach(function (el, index, array) {
    let imgs = el.querySelectorAll("img");
    imgs.forEach(function (img) {
      imagesLoaded(img, function () {
        const parent = img.closest(".image-container");
        parent.classList.remove("loading");
      });
    });
  });
};

function netlifyAdmin() {
  if (window.netlifyIdentity) {
    window.netlifyIdentity.on("init", user => {
      if (!user) {
        window.netlifyIdentity.on("login", () => {
          document.location.href = "/admin/";
        });
      }
    });
  }
};
